import Payment from '../classes/Payment';

export const singleRAData = {
  id: '12345678',
  location: 'GRU1',
  scanned: 'Mon Mar 09 2020 09:58:33 GMT-0300',
  malfunctions: 13.50,
  extras: 0,
  mandatoryParticipation: 0,
  payments: [
    new Payment({type: 'Cartão', amount: 1424.05, descReplacement: 0}),
    new Payment({type: 'Cartão', amount: 1424.05, descReplacement: 0}),
    new Payment({type: 'Cartão', amount: 1424.05, descReplacement: 0}),
  ]
};
